import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';

import '../dropdown/Dropdown.sass';

// A plain single-select dropdown reusing the shared .dropdown styling, but —
// unlike the shared Dropdown component — the trigger keeps showing the selected
// label and every option stays in the list with the current one highlighted.
// options: [{ value, label }] (label may be a node). value/onChange are controlled.
export default function ReviewsSelect({ options, value, onChange, wide }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const hide = (event) => {
      if (!ref.current || !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Defer so the click that opened the menu doesn't immediately close it.
    const timer = setTimeout(() => window.addEventListener('click', hide), 1);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('click', hide);
    };
  }, [isOpen]);

  const selected = options.find((option) => option.value === value) || options[0];

  const pick = (event, option) => {
    event.stopPropagation();
    setIsOpen(false);
    if (option.value !== value) {
      onChange(option.value);
    }
  };

  return (
    <div
      ref={ref}
      className={cx('dropdown', isOpen && 'dropdown--active', wide && 'dropdown--wide')}
      onClick={() => setIsOpen((open) => !open)}
    >
      <button type="button" className="dropdown__trigger">
        {selected && selected.label}
      </button>

      <div className="dropdown__content">
        {options.map((option) => (
          <div
            key={option.value == null ? 'all' : option.value}
            className={cx('dropdown__item', option.value === value && 'dropdown__item--active')}
            onClick={(event) => pick(event, option)}
          >
            {option.label}
          </div>
        ))}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/reviews/ReviewsSelect.js